<div class="skeleton-card">
    <div class="skeleton-left">
        <div class="skeleton circle"></div>
    </div>
    <div class="skeleton-right">
        <div class="skeleton w40 h10 mb5"></div>
        <div class="skeleton w25 h10 mb5"></div>
        <div class="skeleton w30 h10"></div>
    </div>
</div>
